// Este archivo sólo existe para exponer `window.hbUtils` a las vistas que
// todavía no importan por módulo. NO debe tener implementaciones propias: era
// una copia literal de utils/helpers.js y quedó desincronizada cuando helpers
// se migró al Formato Regional (helpers mostraba 24h y esta copia seguía en
// 12h con a.m./p.m. en español, que es lo que veía Proyectos.vue).
import dayjs from './dayjs';
import { formattDate, formattDateHora, formattDateHoraSinAMPM } from './helpers';
import { formatNumber } from './formatProjectData';

function validateDate(dateStart, dateEnd) {
  if (dayjs(dateStart).isBefore(dayjs(dateEnd))) {
    //toasted("La dateStart es anterior a ahora", "success");
    return true;
  } else if (dayjs(dateStart).isAfter(dayjs(dateEnd))) {
    toasted("La Fecha Inicial es mayor a la Fecha Final", "danger");
    return false;
  } else {
    //toasted("La dateStart es igual a ahora", "info");
    return true;
  }
}

function toasted(mensaje, type = "dark") {
  const typeMap = {
    success: "success",
    ok: "success",
    error: "danger",
    danger: "danger",
    warning: "warning",
    advertencia: "warning",
    info: "info",
    primary: "primary",
    secondary: "secondary",
    dark: "dark",
    light: "light"
  };

  const bootstrapType = typeMap[type] || "dark"; // por defecto, usa 'dark'

  // Toast propio con alertas de Bootstrap (mismo enfoque que helpers.js).
  // El mensaje se inserta como TEXTO (no HTML) para evitar XSS con datos del servidor.
  const alertHtml = `
    <div class="alert alert-${bootstrapType} alert-dismissible fade show m-0 mb-1 px-3 py-2 fw-semibold" role="alert">
      <span class="toasted-message"></span>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  `;

  const container = document.createElement('div');
  container.className = 'position-fixed top-0 start-50 translate-middle-x mt-3';
  container.style.zIndex = '9999';
  container.innerHTML = alertHtml;
  container.querySelector('.toasted-message').textContent = mensaje;
  document.body.appendChild(container);

  setTimeout(() => {
    container.remove();
  }, 3000);
}

// Antes armaba el número a mano: toFixed(2) + toLocaleString('es-ES') para los
// miles + concatenar la coma decimal. Formato español fijo, ajeno al proyecto.
function formattNumber(number) {
  return formatNumber(number, undefined, { decimals: 2, fallback: '' });
}

const capitalizeLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function toUpperCase(str) {
  return str.toUpperCase();
}

// formattDate / formattDateHora / formattDateHoraSinAMPM se importan de
// utils/helpers.js (implementación canónica, ya migrada al catálogo de
// formatos). Acá había copias literales que quedaron atrás.

function compareProyect() {
  if (sessionStorage.getItem('proyectSelected') == 11) {
    return true;
  }
  return false
}

const isNumericLike = (v) => {
  if (v == null || v === '') return false;
  if (typeof v === 'number') return Number.isFinite(v);

  const s = String(v).trim();
  if (!s) return false;

  // Soporta: "12.34", "12,34", "1.234,56", "1,234.56"
  // quitamos miles y normalizamos decimal
  const normalized = s
    .replace(/\s/g, '')
    .replace(/\.(?=\d{3}(\D|$))/g, '')   // puntos como miles
    .replace(/,(?=\d{3}(\D|$))/g, '')    // comas como miles
    .replace(',', '.');                  // decimal a punto
  const n = Number(normalized);
  return Number.isFinite(n);
};

const toNumberFlexible = (v) => {
  if (typeof v === 'number') return v;
  const s = String(v).trim()
    .replace(/\s/g, '')
    .replace(/\.(?=\d{3}(\D|$))/g, '') // puntos como miles
    .replace(/,(?=\d{3}(\D|$))/g, '') // comas como miles
    .replace(',', '.'); // decimal a punto
  const n = Number(s);
  return Number.isFinite(n) ? n : NaN;
};

// Tenía 'es-CL' incrustado. El nombre queda por compatibilidad con hbUtils,
// pero ya no fuerza un locale: usa el del proyecto.
const formatEsCL = (v, maxDec = 3) => {
  const n = toNumberFlexible(v);
  if (!Number.isFinite(n)) return (v == null || v === '' ? '-' : v);
  return formatNumber(n, undefined, { grouping: false, minDecimals: 0, maxDecimals: maxDec });
};

function afterBeforeTime(fechaStr) {
  const ahora = new Date();
  const fecha = new Date(fechaStr.replace(' ', 'T'));

  const diffMs = ahora - fecha;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHoras = Math.floor(diffMin / 60);
  const diffDias = Math.floor(diffHoras / 24);
  const diffSemanas = Math.floor(diffDias / 7);
  const diffMeses = Math.floor(diffDias / 30);

  if (diffMin < 1) return 'Hace 1 min';
  if (diffMin < 60) return `Hace ${diffMin} min`;
  if (diffHoras < 24) return `Hace ${diffHoras} hora${diffHoras > 1 ? 's' : ''}`;
  if (diffDias < 7) return `Hace ${diffDias} día${diffDias > 1 ? 's' : ''}`;
  if (diffSemanas < 4) return `Hace ${diffSemanas} semana${diffSemanas > 1 ? 's' : ''}`;
  if (diffMeses <= 3) return `Hace ${diffMeses} mes${diffMeses > 1 ? 'es' : ''}`;

  // Más de 3 meses → mostrar fecha
  return fechaStr;
}


window.hbUtils = {
  validateDate,
  toasted,
  formattNumber,
  capitalizeLetter,
  toUpperCase,
  formattDate,
  formattDateHora,
  formattDateHoraSinAMPM,
  compareProyect,
  isNumericLike,
  toNumberFlexible,
  formatEsCL,
  afterBeforeTime
}